// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  NODE_TLS_REJECT_UNAUTHORIZED: 0,
  interceptorExcludedUrls: [
    'https://pbdemo.ddns.net/be/api/auth/v1.0/login'
  ],
  apiUrl: 'https://pbdemo.ddns.net/be',
  endpoints: {
    auth: '/api/auth/v1.0',
    configuration: '/api/configurations/v1.0',
    patients: '/api/patients/v1.0',
    patientsClassifier: '/api/patients-classifier/v1.0',
    users: '/api/users/v1.0'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
